import React from 'react'

import { Card, Grid, Typography, Box, Button } from '@mui/material'

import { useContext, useState } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { useFormDebounce } from 'hooks/useFormDebounce'
import { useModal } from 'components/modals'
import { selectData } from 'layouts/onboarding'

function QuickReference({
  sendToGoogleSheets,
  sendToSalesforce,
  updateSalesforce,
  sendICToSalesforce,
  sendWelcomeEmail,
}) {
  const {
    intakeState,
    updateIntakeStateAtKey,
    updateUser,
    userTasks,
    currentErrors,
    isAdmin,
  } = useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()
  const { openModal } = useModal()

  return (
    <Card
      id="quick-reference"
      sx={{
        overflow: 'visible',
        textAlign: 'left',
        boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
        borderRadius: 2,
        p: 2,
        mt: -4,
      }}
    >
      <Grid container columnSpacing={3} rowSpacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4">Quick Reference</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box>
            <Button
              variant="parcoRounded"
              sx={[
                {
                  fontSize: '15px',
                  padding: '10px 24px 9px',
                  backgroundColor: '#449d48',
                  borderColor: '#449d48',
                  color: '#fff',
                  fontWeight: 'normal',
                  boxShadow: 'none',
                  margin: '0px 10px 10px 0px',
                },
                {
                  '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                    transform: 'none',
                    backgroundColor: '#4CAF50',
                    borderColor: '#4CAF50',
                    boxShadow: 'none',
                  },
                },
              ]}
              onClick={sendToGoogleSheets}
            >
              Create Client Output
            </Button>
            <Button
              variant="parcoRounded"
              sx={[
                {
                  fontSize: '15px',
                  padding: '10px 24px 9px',
                  backgroundColor: '#449d48',
                  borderColor: '#449d48',
                  color: '#fff',
                  fontWeight: 'normal',
                  boxShadow: 'none',
                  margin: '0px 10px 10px 0px',
                },
                {
                  '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                    transform: 'none',
                    backgroundColor: '#4CAF50',
                    borderColor: '#4CAF50',
                    boxShadow: 'none',
                  },
                },
              ]}
              onClick={sendToSalesforce}
            >
              Create Lead in SF
            </Button>
            <Button
              variant="parcoRounded"
              disabled={
                !intakeState.salesforceAccountID ||
                intakeState.salesforceAccountID.trim() === ''
              }
              sx={{
                fontSize: '15px',
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                borderColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
                margin: '0px 10px 10px 0px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  borderColor: '#293852',
                  boxShadow: 'none',
                },
              }}
              onClick={updateSalesforce}
            >
              Update Client SF
            </Button>
            {/* <Button
                        variant="contained"
                        disabled={
                          !intakeState.salesforceAccountID ||
                          intakeState.salesforceAccountID.trim() === ''
                        }
                        id="update-sf-button"
                        sx={{
                          fontSize: '15px',
                          padding: '10px 24px 9px',
                          backgroundColor: '#344767',
                          color: '#fff',
                          fontWeight: 'normal',
                          boxShadow: 'none',
                          margin: '0px 10px 10px 0px',
                          '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                            transform: 'none',
                            backgroundColor: '#293852',
                            boxShadow: 'none',
                          },
                        }}
                        onClick={updateSalesforceTwo}
                      >
                        Update Client SF (Automation)
                      </Button> */}
            <Button
              variant="parcoRounded"
              disabled={
                !intakeState.salesforceICEventID ||
                intakeState.salesforceICEventID.trim() === ''
              }
              sx={{
                fontSize: '15px',
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                borderColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
                margin: '0px 10px 10px 0px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  borderColor: '#293852',
                  boxShadow: 'none',
                },
              }}
              onClick={sendICToSalesforce}
            >
              Update IC Notes
            </Button>

            {/* <Button
              variant="contained"
              sx={{
                fontSize: '15px',
                padding: '10px 24px 9px',
                backgroundColor: '#344767',
                color: '#fff',
                fontWeight: 'normal',
                boxShadow: 'none',
                margin: '0px 10px 10px 0px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  backgroundColor: '#293852',
                  boxShadow: 'none',
                },
              }}
              onClick={sendToRetirementPaperwork}
            >
              Create Retirement Paperwork
            </Button> */}
            <Button
              rel="noreferrer"
              variant="parcoRounded"
              onClick={() => openModal('createOpportunityModal')}
              disabled={
                !intakeState.salesforceAccountID ||
                intakeState.salesforceAccountID.trim() === ''
              }
              sx={{
                fontSize: '15px',
                padding: '10px 24px 9px',
                fontWeight: 'normal',
                boxShadow: 'none',
                margin: '0px 10px 10px 0px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  boxShadow: 'none',
                },
              }}
            >
              Create FIA Opportunity
            </Button>
            <Button
              variant="parcoRounded"
              sx={{
                fontSize: '15px',
                padding: '10px 24px 9px',
                fontWeight: 'normal',
                boxShadow: 'none',
                margin: '0px 10px 10px 0px',
                '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                  transform: 'none',
                  boxShadow: 'none',
                },
              }}
              onClick={sendWelcomeEmail}
            >
              Send Welcome Email
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {renderMuiFormField({
            autoFocus: false,
            id: 'retirementStrategist',
            label: 'Primary Strategist',
            placeholder: 'Primary Strategist',
            inputType: 'select',
            value: intakeState.retirementStrategist,
            onChange: updateIntakeStateAndSubmit((retirementStrategist) =>
              updateIntakeStateAtKey({ retirementStrategist })
            ),
            options: selectData.retirementStrategist,
          })}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {renderMuiFormField({
            id: 'salesforceAccountID',
            label: 'Salesforce Account ID',
            placeholder: 'Salesforce Account ID',
            inputType: 'text',
            value: intakeState.salesforceAccountID,
            onChange: updateIntakeStateAndSubmit((salesforceAccountID) =>
              updateIntakeStateAtKey({ salesforceAccountID })
            ),
          })}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {renderMuiFormField({
            id: 'salesforceLeadID',
            label: 'Salesforce Lead ID',
            placeholder: 'Salesforce Lead ID',
            inputType: 'text',
            value: intakeState.salesforceLeadID,
            onChange: updateIntakeStateAndSubmit((salesforceLeadID) =>
              updateIntakeStateAtKey({ salesforceLeadID })
            ),
          })}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          {renderMuiFormField({
            id: 'salesforceICEventID',
            label: 'Salesforce IC Event ID',
            placeholder: 'Salesforce IC Event ID',
            inputType: 'text',
            value: intakeState.salesforceICEventID,
            onChange: updateIntakeStateAndSubmit((salesforceICEventID) =>
              updateIntakeStateAtKey({ salesforceICEventID })
            ),
          })}
        </Grid>
      </Grid>
    </Card>
  )
}

export default QuickReference
